import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CalendarModule } from "primeng/calendar";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { FloatLabelModule } from "primeng/floatlabel";
import { MultiSelectModule } from "primeng/multiselect";
import { CollectionService } from "src/app/modules/speech2text/services/collection.service";

export type CollectionInfo = {
  id: string;
  name: string;
};

export type CollectionFilters = {
  collections: CollectionInfo[];
  period?: (Date | null)[];
};

@Component({
  selector: "app-collections-multi-select",
  standalone: true,
  imports: [MultiSelectModule, ConfirmDialogModule, CommonModule, FormsModule, FloatLabelModule, CalendarModule],
  templateUrl: "./collections-multi-select.component.html",
  styleUrl: "./collections-multi-select.component.scss",
})
export class CollectionMultiSelectComponent implements OnInit {
  collectionsOptions: CollectionInfo[] = [];
  period?: (Date | null)[];
  collectionsSelected: CollectionInfo[] = [];
  protected readonly dialogConfig = inject(DynamicDialogConfig);
  protected readonly collectionService = inject(CollectionService);

  protected readonly ref = inject(DynamicDialogRef);

  async ngOnInit(): Promise<void> {
    this.collectionsSelected = this.dialogConfig.data?.collections ?? [];
    this.period = this.dialogConfig.data?.period ?? [];
    const result = await this.collectionService.findAutomaticEmbeddingsCreation();
    this.collectionsOptions = result
      .map((c) => ({ id: c.id, name: c.title }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  clearDate(): void {
    this.period = undefined;
  }

  onClose(): void {
    const embeddingData: CollectionFilters = {
      collections: this.collectionsSelected,
      period: this.period,
    };
    this.ref.close(embeddingData);
  }
}
